import React from 'react';
import { Link } from 'react-router-dom';

export default function Support() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Help</span>
        <h1 className="page-title section-gap">Support</h1>
        <p className="page-subtitle">{'KinetoCut'} — this page is a placeholder. Content coming soon.</p>
        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
